module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/Facebook.ed5b2299.svg";